// extracted by mini-css-extract-plugin
module.exports = {"wrapperFound":"jfRjc","header":"_3MGl6","text":"_3SLFU","title":"_2edBr","secondBlock":"rn1kP","topCategories":"_1tmJW","secondTitle":"_3OYPw"};